import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { PlanOptionType} from "@/types/PlansType"
import { http } from "@/utils/http"
import { AxiosResponse } from "axios"
import { PlanOptionFormType } from "@/types/api/plan"
import {
  GET_ADD_OPTIONS_URL,
  GET_UPDATE_DELETE_OPTION_URL,
} from "@/constants/api/endpoints"


// Todo review the response from the update an the create function
interface FetchOptionsParams {
  type?: string;
}
// Fetch all options
export const fetchOptions = createAsyncThunk("option/fetchOptions", async (params:FetchOptionsParams, thunkApi) => {
  return http
    .get<PlanOptionType[]>(GET_ADD_OPTIONS_URL, {params})
    .then((res): PlanOptionType[] => res.data)
    .catch(e => {
      return thunkApi.rejectWithValue({ data: e.data })
    })
})

// Create a option
export const createAsyncOption = createAsyncThunk<PlanOptionType, PlanOptionFormType>(
  "option/createAsyncOption",
  async (option: Partial<PlanOptionFormType>, thunkApi) => {
    return http
      .post<PlanOptionType>(GET_ADD_OPTIONS_URL, option)
      .then((res): PlanOptionType => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// Update an existing option
export const updateAsyncOption = createAsyncThunk<PlanOptionType, {
  id?: string,
  data?: Partial<PlanOptionFormType | FormData>,
}>(
  "option/updateAsyncOption",
  async ({ id, data }: {
    id?: string,
    data?: Partial<PlanOptionFormType | FormData>,
  }, thunkApi) => {
    return http
      .patch<PlanOptionType>(GET_UPDATE_DELETE_OPTION_URL.replace(":id", `${id}`), data)
      .then((res): PlanOptionType => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// Delete an existing option
export const deleteAsyncOption = createAsyncThunk<AxiosResponse, { id: string }>(
  "option/deleteAsyncOption",
  async ({ id }: { id: string }, thunkApi) => {
    return http
      .delete<AxiosResponse>(GET_UPDATE_DELETE_OPTION_URL.replace(":id", id))
      .then(res => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

const initialOptionState =[
  {
    "id": "b2c3d4e5-f6a7-4b8c-9d0e-1f2a3b4c5d6e",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Profils des collaborateurs",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "c3d4e5f6-a7b8-4c9d-0e1f-2a3b4c5d6e7f",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Gestion des Equipes de travail",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "d4e5f6a7-b8c9-4d0e-1f2a-3b4c5d6e7f8a",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Registre du personnel",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "e5f6a7b8-c9d0-4e1f-2a3b-4c5d6e7f8a9b",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Organigramme des collaborateurs",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "f6a7b8c9-d0e1-4f2a-3b4c-5d6e7f8a9b0c",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Validation des demandes d'absences",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "a7b8c9d0-e1f2-4a3b-4c5d-6e7f8a9b0c1d",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Validation des acomptes sur salaire",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "b8c9d0e1-f2a3-4b4c-5d6e-7f8a9b0c1d2e",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Gestions des actions requises",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "c9d0e1f2-a3b4-4c5d-6e7f-8a9b0c1d2e3f",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Synthèse des congés et absences",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "d0e1f2a3-b4c5-4d6e-7f8a-9b0c1d2e3f4a",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Gestion des congés payés",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "e1f2a3b4-c5d6-4e7f-8a9b-0c1d2e3f4a5b",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Gestions des absences",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "f2a3b4c5-d6e7-4f8a-9b0c-1d2e3f4a5b6c",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Planning des congés et absences",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "a3b4c5d6-e7f8-4a9b-0c1d-2e3f4a5b6c7d",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Gestion des primes",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "b4c5d6e7-f8a9-4b0c-1d2e-3f4a5b6c7d8e",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Gestion des Indemnités non soumises",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "c5d6e7f8-a9b0-4c1d-2e3f-4a5b6c7d8e9f",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Gestion des acomptes sur salaire",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "d6e7f8a9-b0c1-4d2e-3f4a-5b6c7d8e9f0a",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Gestion des prêts salariés",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "e7f8a9b0-c1d2-4e3f-4a5b-6c7d8e9f0a1b",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Synthèse des déductions",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "f8a9b0c1-d2e3-4f4a-5b6c-7d8e9f0a1b2c",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Gestion des heures supplémentaires",
    "amount": 0,
    "type": "ADDON",
    "is_active": true
  },
  {
    "id": "a9b0c1d2-e3f4-4a5b-6c7d-8e9f0a1b2c3d",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Génération des bulletins du mois",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "b0c1d2e3-f4a5-4b6c-7d8e-9f0a1b2c3d4e",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Historique des bulletins de salaire",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "c1d2e3f4-a5b6-4c7d-8e9f-0a1b2c3d4e5f",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Synthèse des déclarations et Organismes",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "d2e3f4a5-b6c7-4d8e-9f0a-1b2c3d4e5f6a",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Déclarations CNSS",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Impôts salariés et Impôts prestataires",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "f8e7d6c5-b4a3-4f2e-9d1c-8b0a7f6e5d4c",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Gestion des documents d'entreprise",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "c0d1e2f3-a4b5-4c6d-7e8f-9a0b1c2d3e4f",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Génération de documents",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "b3a2c1d0-f4e5-4a6b-8c7d-9e0f1a2b3c4d",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Corbeille des documents",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "ec59910d-2a1e-4573-8b74-279c6d3e1f0a",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Modes de paiement",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "f6b4c19a-9d20-4351-b8f2-0e3c5a6d7b8f",
    "is_deleted": false,
    "deleted_at": null,
    "label": "États de paiement des salaires",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "a1e8b3c4-5d9f-4e0a-a1b2-c3d4e5f6a7b8",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Virements bancaires des salaires",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "b3c7d0e1-4f5a-4b6c-c7d8-e9f0a1b2c3d4",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Virements mobile money des salaires",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "c8f0a1b2-3d4e-4f5a-8b6c-7d8e9f0a1b2c",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Livre de paie",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "d5a6b7c8-9d0e-4f1a-b2c3-d4e5f6a7b8c9",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Écritures comptables",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "e2f4a5b6-c7d8-4e9f-9a0b-1c2d3e4f5a6b",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Provisions de congés payés",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "f9d0e1a2-b3c4-4d5e-a6f7-b8c9d0e1f2a3",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Indicateurs RH",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "a7b8c9d0-e1f2-4a3b-8c4d-5e6f7a8b9c0d",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Similateur de coût",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "b1d2e3f4-5a6b-4c7d-9e8f-0a1b2c3d4e5f",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Facturation",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "e5b6c7d8-e9f0-4a1b-9c2d-3e4f5a6b7c8d",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Parrainage de proche",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  },
  {
    "id": "c6d7e8f9-0a1b-4c2d-8e3f-4a5b6c7d8e9f",
    "is_deleted": false,
    "deleted_at": null,
    "label": "Gestion des accès",
    "amount": 0,
    "type": "DEFAULT",
    "is_active": true
  }
]
// initial state
const initialState: {
  options: PlanOptionType[],
  optionsStatus: string,
  optionsErrors?: any,

  addOptionStatus: string,
  addOptionErrors?: any,

  deleteOptionErrors?: any,
  deleteOptionStatus: string,
} = {
  options: initialOptionState,
  optionsStatus: "idle",
  addOptionStatus: "idle",
  deleteOptionStatus: "idle",
}

const optionsSlice = createSlice({
  name: "options",
  initialState,
  reducers: {},

  extraReducers(builder) {
    // get  all options
    builder
      .addCase(fetchOptions.pending, (state) => {
        state.optionsStatus = "loading"
      })
      .addCase(fetchOptions.fulfilled, (state, action) => {
        state.optionsStatus = "succeeded"
        state.options = action.payload
      })
      .addCase(fetchOptions.rejected, (state, action) => {
        state.optionsStatus = "failed"
        state.optionsErrors = action.error
      })

    builder
      .addCase(createAsyncOption.pending, (state) => {
        state.addOptionStatus = "loading"
      })
      .addCase(createAsyncOption.fulfilled, (state, action) => {
        state.addOptionStatus = "succeeded"
        state.options = [action.payload, ...state.options ]

      })
      .addCase(createAsyncOption.rejected, (state, action) => {
        state.addOptionStatus = "failed"
        state.addOptionErrors = action.error
      })

    builder
      .addCase(updateAsyncOption.pending, (state) => {
        state.optionsStatus = "loading"
      })
      .addCase(updateAsyncOption.fulfilled, (state, action) => {
        state.optionsStatus = "succeeded"
        let index = state.options.findIndex(option => option.id === action.meta.arg.id)
        state.options[index] = action.payload

      })
      .addCase(updateAsyncOption.rejected, (state, action) => {
        state.optionsStatus = "failed"
        state.optionsErrors = action.error
      })

    builder
      .addCase(deleteAsyncOption.pending, (state) => {
        state.deleteOptionStatus = "loading"
      })
      .addCase(deleteAsyncOption.fulfilled, (state, action) => {
        state.optionsStatus = "succeeded"
        state.options = state.options.filter((option) => option.id !== action.meta.arg.id)
      })
      .addCase(deleteAsyncOption.rejected, (state, action) => {
        state.deleteOptionStatus = "failed"
        state.deleteOptionErrors = action.error
      })

  },
})

export default optionsSlice.reducer

